var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus,"keyup":_vm.onKeyup,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }